/* ============================================
   ZENITH PERFORMANCE — SHOPIFY THEME JS
   Cart AJAX, theme toggle, FAQ accordion,
   variant selectors, testimonials carousel,
   promo codes, mobile nav, stock status
   ============================================ */

// Apply a promo/discount code by redirecting through Shopify's real
// discount-code endpoint. Shopify validates the code server-side (so this
// works for ANY active discount code in the store, not just a hardcoded
// list) and redirects back to the cart page so the discount is visible
// there before checkout.
function applyShopifyPromo(event) {
  if (event && event.preventDefault) event.preventDefault();
  const input = document.getElementById('promo-input');
  const msg = document.getElementById('promo-message');
  if (!input || !msg) return;
  const code = input.value.trim();
  if (!code) {
    msg.textContent = 'Please enter a code.';
    msg.className = 'promo-message error';
    return;
  }
  msg.textContent = 'Applying code…';
  msg.className = 'promo-message';
  // Redirect to Shopify's discount endpoint, which validates the code and
  // applies it to the cart/checkout, then sends the shopper back to /cart
  // so they see the discount reflected before checking out.
  window.location.href = window.shopUrl + '/discount/' + encodeURIComponent(code) + '?redirect=/cart';
}

// --- Cart Drawer (Shopify AJAX API) ---
function openCartDrawer() {
  document.querySelector('.cart-overlay')?.classList.add('open');
  document.querySelector('[data-cart-drawer]')?.classList.add('open');
  document.body.style.overflow = 'hidden';
  fetchCart();
}

function closeCartDrawer() {
  document.querySelector('.cart-overlay')?.classList.remove('open');
  document.querySelector('[data-cart-drawer]')?.classList.remove('open');
  document.body.style.overflow = '';
}

async function fetchCart() {
  try {
    const res = await fetch(window.routes.cart, { headers: { 'Accept': 'application/json' } });
    const cart = await res.json();
    renderCart(cart);
  } catch (e) {
    console.error('Cart fetch error:', e);
  }
}

function renderCart(cart) {
  const countEl = document.querySelector('[data-cart-count]');
  if (countEl) {
    countEl.textContent = cart.item_count > 0 ? String(cart.item_count) : '';
    countEl.setAttribute('data-count', String(cart.item_count));
  }

  const body = document.querySelector('[data-cart-drawer-body]');
  const footer = document.querySelector('[data-cart-drawer-footer]');
  if (!body || !footer) return;

  if (cart.item_count === 0) {
    body.innerHTML = '<div class="cart-empty"><p>Your cart is empty.</p><p style="margin-top:8px;">Browse our Zen Grip to get started.</p></div>';
    footer.style.display = 'none';
  } else {
    body.innerHTML = cart.items.map(function(item, i) {
      var itemDiscountTag = '';
      if (item.discounts && item.discounts.length > 0) {
        itemDiscountTag = '<div class="cart-item-discount-tag">' + item.discounts.map(function(d) {
          return '🏷️ ' + d.title + ' (-$' + (d.amount / 100).toFixed(2) + ')';
        }).join(', ') + '</div>';
      }
      return '\
      <div class="cart-item">\
        <div class="cart-item-img">' + (item.image ? '<img src="' + item.image + '" alt="' + item.title + '" style="width:60px;height:60px;object-fit:cover;border-radius:var(--radius-md);">' : '') + '</div>\
        <div class="cart-item-info">\
          <h4>' + item.product_title + '</h4>\
          <div class="variant">' + (item.variant_title || '') + '</div>\
          <div class="variant">Qty: ' + item.quantity + '</div>\
          ' + itemDiscountTag + '\
          <button class="cart-item-remove" onclick="changeCartItem(' + (i + 1) + ', 0)">Remove</button>\
        </div>\
        <div class="cart-item-price">$' + (item.final_line_price / 100).toFixed(2) + '</div>\
      </div>';
    }).join('');

    footer.style.display = 'block';
    var total = cart.total_price / 100;
    var discountRow = '';
    if (cart.total_discount && cart.total_discount > 0) {
      var discountLabel = 'Discount applied';
      if (cart.cart_level_discount_applications && cart.cart_level_discount_applications.length > 0) {
        discountLabel = cart.cart_level_discount_applications.map(function(d) { return d.title; }).join(', ');
      } else if (cart.items && cart.items[0] && cart.items[0].discounts && cart.items[0].discounts.length > 0) {
        discountLabel = cart.items[0].discounts.map(function(d) { return d.title; }).join(', ');
      }
      discountRow = '\
      <div class="cart-discount">\
        <span>🏷️ ' + discountLabel + '</span>\
        <span class="amount">-$' + (cart.total_discount / 100).toFixed(2) + '</span>\
      </div>';
    }
    footer.innerHTML = '\
      <div class="cart-promo">\
        <div class="cart-promo-row">\
          <input type="text" id="promo-input" placeholder="Promo code" autocomplete="off">\
          <button type="button" id="promo-apply-btn" class="btn btn-outline" onclick="applyShopifyPromo(event)">Apply</button>\
        </div>\
        <div id="promo-message" class="promo-message"></div>\
      </div>\
      ' + discountRow + '\
      <div class="cart-subtotal">\
        <span>Subtotal</span>\
        <span class="amount">$' + total.toFixed(2) + '</span>\
      </div>\
      <button class="btn btn-accent btn-block btn-lg" onclick="window.location.href=\'' + window.shopUrl + '/checkout\'">Checkout</button>\
      <p class="cart-note">Shipping and taxes calculated at checkout.</p>';
  }
}

async function addToCartAjax(variantId, quantity) {
  try {
    const res = await fetch(window.routes.cart_add, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity || 1 })
    });
    if (res.ok) {
      fetchCart();
      openCartDrawer();
    } else {
      const data = await res.json();
      alert(data.description || 'Could not add to cart.');
    }
  } catch (e) {
    console.error('Add to cart error:', e);
  }
}

async function changeCartItem(line, quantity) {
  try {
    await fetch(window.routes.cart_change, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    });
    // On the full cart page, reload so line items / prices re-render server-side
    if (document.getElementById('cart-form')) {
      location.reload();
      return;
    }
    fetchCart();
  } catch (e) {
    console.error('Cart change error:', e);
  }
}

function addToCartVariant(packLabel) {
  var select = document.getElementById('variant-select');
  if (!select) return;
  for (var i = 0; i < select.options.length; i++) {
    if (select.options[i].text.indexOf(packLabel) > -1) {
      select.selectedIndex = i;
      addToCartAjax(select.value, 1);
      return;
    }
  }
}

// Bundle buttons: pick the pack (with the selected color if any) and add it
function selectBundleAndAdd(packId) {
  var map = { 'pack-4': '4-Pack', 'pack-12': '12-Pack', 'pack-20': '20-Pack' };
  var packLabel = map[packId];
  if (!packLabel) return;
  var select = document.getElementById('variant-select');
  if (!select) return;
  var colorBtn = document.querySelector('.variant-group[data-group="color"] .variant-option.selected');
  var color = colorBtn ? colorBtn.getAttribute('data-variant-value') : '';
  for (var i = 0; i < select.options.length; i++) {
    var parts = select.options[i].getAttribute('data-title').split(' / ');
    var colorOk = !color || parts.indexOf(color) > -1;
    if (colorOk && parts.indexOf(packLabel) > -1) {
      select.selectedIndex = i;
      addToCartAjax(select.value, 1);
      return;
    }
  }
  for (var j = 0; j < select.options.length; j++) {
    if (select.options[j].getAttribute('data-title').indexOf(packLabel) > -1) {
      select.selectedIndex = j;
      addToCartAjax(select.value, 1);
      return;
    }
  }
}

// --- Gallery: click a thumbnail to swap the main image ---
function zenShowGalleryImage(src) {
  var mainImg = document.querySelector('.gallery-main img');
  if (!mainImg || !src) return;
  mainImg.src = src;
  // Highlight the thumbnail now on display
  document.querySelectorAll('.gallery-thumb').forEach(function(t) {
    var m = (t.style.background || '').match(/url\(['\"]?(.+?)['\"]?\)/);
    var hit = !!m && (m[1].indexOf(src) !== -1 || src.indexOf(m[1]) !== -1);
    t.classList.toggle('active', hit);
  });
}

document.addEventListener('click', function(e) {
  var thumb = e.target.closest('.gallery-thumb');
  if (!thumb) return;
  document.querySelectorAll('.gallery-thumb').forEach(function(t) { t.classList.remove('active'); });
  thumb.classList.add('active');
  var bg = thumb.style.background;
  var match = bg.match(/url\(['\"]?(.+?)['\"]?\)/);
  if (match) {
    var mainImg = document.querySelector('.gallery-main img');
    if (mainImg) mainImg.src = match[1];
  }
});

// --- Stock Status: update button, message, and pack option visuals ---
function updateStockStatus(available) {
  var addBtn = document.querySelector('[data-add-to-cart]');
  var stockMsg = document.querySelector('[data-stock-status]');
  if (available) {
    if (addBtn) {
      addBtn.textContent = 'Add to Cart';
      addBtn.classList.remove('btn-out-of-stock');
      addBtn.disabled = false;
    }
    if (stockMsg) stockMsg.style.display = 'none';
  } else {
    if (addBtn) {
      addBtn.textContent = 'Out of Stock';
      addBtn.classList.add('btn-out-of-stock');
      addBtn.disabled = true;
    }
    if (stockMsg) stockMsg.style.display = 'block';
  }
}

// Mark pack-size buttons that have no available variants (all colors OOS for that pack)
function markUnavailablePacks() {
  var select = document.getElementById('variant-select');
  if (!select) return;
  var packBtns = document.querySelectorAll('.variant-group[data-group="pack"] .variant-option');
  packBtns.forEach(function(btn) {
    var packValue = btn.getAttribute('data-variant-value');
    // Check if ANY variant with this pack size is available
    var anyAvailable = false;
    for (var i = 0; i < select.options.length; i++) {
      var parts = select.options[i].getAttribute('data-title').split(' / ');
      if (parts.indexOf(packValue) > -1 && select.options[i].getAttribute('data-available') === 'true') {
        anyAvailable = true;
        break;
      }
    }
    if (anyAvailable) {
      btn.classList.remove('unavailable');
    } else {
      btn.classList.add('unavailable');
    }
  });
}

// Check stock for the currently selected variant and update UI
function checkSelectedVariantStock() {
  var select = document.getElementById('variant-select');
  if (!select || select.selectedIndex < 0) return;
  var available = select.options[select.selectedIndex].getAttribute('data-available') === 'true';
  updateStockStatus(available);
}

// --- Variant Selectors ---
document.addEventListener('click', function(e) {
  if (!e.target.closest('.variant-option')) return;
  var btn = e.target.closest('.variant-option');
  var group = btn.closest('.variant-group');
  if (!group) return;

  // Don't allow selecting an unavailable pack option
  if (btn.classList.contains('unavailable')) return;

  group.querySelectorAll('.variant-option').forEach(function(opt) {
    opt.classList.remove('selected');
  });
  btn.classList.add('selected');

  // Color swatch -> show that color's grip image in the gallery
  if (group.getAttribute('data-group') === 'color') {
    var colorImg = (window.ZEN_COLOR_IMAGES || {})[btn.getAttribute('data-variant-value')];
    if (colorImg) zenShowGalleryImage(colorImg);
  }

  var select = document.getElementById('variant-select');
  if (!select) return;

  // Match the variant for the currently selected color AND pack (exact option-part
  // match, so "Purple" won't accidentally match "Lilac Purple")
  var colorBtn = document.querySelector('.variant-group[data-group="color"] .variant-option.selected');
  var packBtn = document.querySelector('.variant-group[data-group="pack"] .variant-option.selected');
  var color = colorBtn ? colorBtn.getAttribute('data-variant-value') : '';
  var pack = packBtn ? packBtn.getAttribute('data-variant-value') : '';

  var matched = null;
  for (var i = 0; i < select.options.length; i++) {
    var parts = select.options[i].getAttribute('data-title').split(' / ');
    var colorOk = !color || parts.indexOf(color) > -1;
    var packOk = !pack || parts.indexOf(pack) > -1;
    if (colorOk && packOk) { matched = i; break; }
  }
  if (matched !== null) {
    select.selectedIndex = matched;
    var priceEl = document.querySelector('[data-product-price]');
    var noteEl = document.querySelector('[data-price-note]');
    var mobilePriceEl = document.querySelector('[data-mobile-price]');
    var price = select.options[matched].getAttribute('data-price');
    var title = select.options[matched].getAttribute('data-title');
    var available = select.options[matched].getAttribute('data-available') === 'true';
    if (priceEl && price) priceEl.textContent = '$' + parseFloat(price).toFixed(2);
    if (noteEl && title) noteEl.textContent = '/ ' + title;
    if (mobilePriceEl && price) mobilePriceEl.textContent = '$' + parseFloat(price).toFixed(2);
    // Update stock status immediately when variant changes
    updateStockStatus(available);
  }
});

// --- Product Form Submit (AJAX) ---
document.addEventListener('submit', function(e) {
  var form = e.target.closest('[data-product-form]');
  if (!form) return;
  e.preventDefault();

  var formData = new FormData(form);
  var variantId = formData.get('id');
  var quantity = parseInt(formData.get('quantity') || '1', 10);

  // Block submission if the selected variant is out of stock
  var select = document.getElementById('variant-select');
  if (select && select.selectedIndex >= 0) {
    var available = select.options[select.selectedIndex].getAttribute('data-available') === 'true';
    if (!available) return;
  }

  addToCartAjax(variantId, quantity);
});

// --- Mobile Buy Bar Add to Cart (button lives outside the product form) ---
document.addEventListener('click', function(e) {
  var btn = e.target.closest('[data-add-to-cart]');
  if (!btn) return;
  if (btn.closest('[data-product-form]')) return; // handled by the form submit above
  e.preventDefault();
  var select = document.getElementById('variant-select');
  if (!select || !select.value) return;
  // Block if out of stock
  if (select.selectedIndex >= 0) {
    var available = select.options[select.selectedIndex].getAttribute('data-available') === 'true';
    if (!available) return;
  }
  var qtyInput = document.querySelector('[data-qty-input]');
  var qty = qtyInput ? parseInt(qtyInput.value || '1', 10) : 1;
  addToCartAjax(select.value, qty);
});

// --- Qty Selector ---
document.addEventListener('click', function(e) {
  var dec = e.target.closest('[data-qty-dec]');
  var inc = e.target.closest('[data-qty-inc]');
  if (!dec && !inc) return;

  var input = dec ? dec.parentElement.querySelector('[data-qty-input]') : inc.parentElement.querySelector('[data-qty-input]');
  if (!input) return;
  var val = parseInt(input.value || '1', 10);
  if (dec) input.value = Math.max(1, val - 1);
  if (inc) input.value = val + 1;

  // For cart page line items
  var line = dec ? dec.getAttribute('data-line') : inc.getAttribute('data-line');
  if (line) {
    changeCartItem(parseInt(line), parseInt(input.value));
  }
});

// --- Theme Toggle ---
(function() {
  var toggle = document.querySelector('[data-theme-toggle]');
  var root = document.documentElement;
  var theme = matchMedia('(prefers-color-scheme:dark').matches ? 'dark' : 'light';
  root.setAttribute('data-theme', theme);

  function updateIcon() {
    if (!toggle) return;
    toggle.innerHTML = theme === 'dark'
      ? '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="5"/><path d="M12 1v2M12 21v2M4.22 4.22l1.42 1.42M18.36 18.36l3.42 1.42M1 12h2M21 12h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42"/></svg>'
      : '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/></svg>';
    toggle.setAttribute('aria-label', 'Switch to ' + (theme === 'dark' ? 'light' : 'dark') + ' mode');
  }

  updateIcon();

  if (toggle) {
    toggle.addEventListener('click', function() {
      theme = theme === 'dark' ? 'light' : 'dark';
      root.setAttribute('data-theme', theme);
      try { localStorage.setItem('zenith-theme', theme); } catch(e) {}
      updateIcon();
    });
  }

  // Load saved theme
  try {
    var saved = localStorage.getItem('zenith-theme');
    if (saved) { theme = saved; root.setAttribute('data-theme', theme); updateIcon(); }
  } catch(e) {}
})();

// --- FAQ Accordion ---
document.addEventListener('click', function(e) {
  var q = e.target.closest('.faq-question');
  if (!q) return;
  var item = q.parentElement;
  var isOpen = item.classList.contains('open');
  item.classList.toggle('open');
  item.querySelector('.faq-answer').style.maxHeight = isOpen ? null : item.querySelector('.faq-answer-inner').scrollHeight + 'px';
});

// --- Testimonials Carousel ---
(function() {
  var track = document.querySelector('.testimonial-track');
  if (!track) return;
  var dots = document.querySelectorAll('.testimonial-dot');
  var idx = 0;

  function goTo(i) {
    idx = i;
    track.style.transform = 'translateX(-' + (i * 100) + '%)';
    dots.forEach(function(dot, d) { dot.classList.toggle('active', d === i); });
  }

  dots.forEach(function(dot, d) {
    dot.addEventListener('click', function() { goTo(d); });
  });

  setInterval(function() { goTo((idx + 1) % 3); }, 6000);
})();

// --- Email Capture ---
document.addEventListener('submit', function(e) {
  var form = e.target.closest('.email-form');
  if (!form) return;
  e.preventDefault();
  var success = form.parentElement.querySelector('.email-success');
  if (success) success.style.display = 'block';
  form.reset();
});

// --- Review Filters (cosmetic: toggles active state, matching the storefront) ---
document.addEventListener('click', function(e) {
  var filter = e.target.closest('.review-filter');
  if (!filter) return;
  document.querySelectorAll('.review-filter').forEach(function(f) { f.classList.remove('active'); });
  filter.classList.add('active');
});

// --- Mobile Nav ---
document.addEventListener('click', function(e) {
  var toggle = e.target.closest('.nav-toggle');
  if (!toggle) return;
  document.body.classList.toggle('nav-open');
});

// --- Page Load: initialize stock status and mark unavailable packs ---
document.addEventListener('DOMContentLoaded', function() {
  markUnavailablePacks();
  checkSelectedVariantStock();
});
